import { briefs } from '../data';

export default function BriefTimeline() {
  return (
    <section className="border-b border-foreground-900/10 bg-background-50">
      <div className="mx-auto max-w-6xl px-4 py-8 md:px-6 md:py-12">
        <div className="flex items-end justify-between gap-4 border-b border-foreground-900/10 pb-4">
          <div>
            <p className="kicker text-xs text-primary-600">快讯时间线 · FLASH</p>
            <h2 className="mt-2 font-heading text-2xl font-semibold tracking-tight text-foreground-950 md:text-3xl">
              今日短讯滚动
            </h2>
          </div>
          <span className="hidden whitespace-nowrap text-xs text-foreground-500 sm:block">今日 08:00 起 · 共 {briefs.length} 条</span>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-x-10 lg:grid-cols-2">
          {briefs.map((b, i) => (
            <article
              key={i}
              className="group relative flex gap-4 border-l-2 border-foreground-900/10 py-3 pl-5 transition-colors hover:border-primary-400"
            >
              <span className="absolute -left-[9px] top-5 h-4 w-4 rounded-full border-2 border-primary-500 bg-background-50"></span>
              <span className="w-11 shrink-0 whitespace-nowrap font-mono text-sm text-foreground-600 tabular-nums">{b.time}</span>
              <p className="text-sm leading-relaxed text-foreground-800 transition-colors group-hover:text-primary-800">
                {b.text}
                <span className="ml-2 inline-flex rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] text-secondary-700">{b.tag}</span>
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}